/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
// @ts-nocheck
window.addonsPopup = (function ($) {
  var $popup, $carousel;
  var $activeCard = null;
  var $activeContext = null;
  var swiperMain = null;
  var $accordionTpl = null;

  
  function getSlidesForCard($context) {
    var variantId = $context.find('> input.addOneMainInput__js').attr('data-variant-id');
    var $tpl = variantId
      ? $context.find('> template.addon-gallery-tpl[data-variant-id="' + variantId + '"]')
      : $([]);
    if (!$tpl.length) $tpl = $context.find('> template.addon-gallery-tpl').first();
    if (!$tpl.length) return [];

    var slides = [];
    $($tpl[0].content).find('.addon-popup-slide').each(function () {
      slides.push(this.cloneNode(true));
    });
    return slides;
  }

  function dehandelize(str) {
    return (str || '').replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  // Locale-tolerant money parser. The old version kept only digits + '.', which
  // broke da-DK / de-DE etc. where '.' is the THOUSANDS separator (e.g. "1.149 kr"
  // parsed as 1.149 instead of 1149, hiding the compare price + discount badge).
  // Here: a trailing separator followed by 1-2 digits is the decimal separator;
  // any other '.'/',' are thousands separators and are stripped.
  function priceToNumber(str) {
    var s = String(str || '').replace(/[^0-9.,]/g, '');
    if (!s) return 0;
    var lastSep = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    var frac = lastSep === -1 ? '' : s.slice(lastSep + 1);
    if (frac.length === 1 || frac.length === 2) {
      var n = parseFloat(s.slice(0, lastSep).replace(/[.,]/g, '') + '.' + frac);
      return isNaN(n) ? 0 : n;
    }
    var n2 = parseFloat(s.replace(/[.,]/g, ''));
    return isNaN(n2) ? 0 : n2;
  }

  // Chairs sell at variant price * 0.95, so the badge is the SUM of the base 5% chair
  // discount (original variant price -> chair price) and the variant's own compare-at discount.
  function chairBadge(price, original, compareAt) {
    var p = priceToNumber(price), o = priceToNumber(original), c = priceToNumber(compareAt);
    var base = o > p ? Math.round((1 - p / o) * 100) : 0;
    var variant = c > o ? Math.round((1 - o / c) * 100) : 0;
    var total = base + variant;
    if (total <= 0) return '';
    // Honour the discount-format setting (percent vs saved amount). For "amount" the
    // saved value is (highest price shown) - chair price, so pass the "was" price.
    var wasPrice = c > o ? compareAt : original;
    return window.deskDiscountBadge ? window.deskDiscountBadge(total, price, wasPrice) : '-' + total + '%';
  }

  // Fill the popup price line. secondCompare is the chair compare-at ('' for simple addons);
  // discountText is the badge label ('' hides it). Each element is shown only when meaningful.
  function setPopupPriceLine(price, firstCompare, secondCompare, discountText) {
    var p = priceToNumber(price), f = priceToNumber(firstCompare), s = priceToNumber(secondCompare);
    $popup.find('.add-one_popup_price').text(price);
    $popup.find('.add-one_popup_compare-price').text(firstCompare).toggle(f > p);
    $popup.find('.add-one_popup_compare-at').text(secondCompare).toggle(s > f && s > 0);
    $popup.find('.add-one_popup_compare-badge').text(discountText).toggle(!!discountText);
  }

  function renderVariants($context) {
    var $variants = $context.find('.tac-variants').first();
    // Optional per-addon override for the option label title (product metafield
    // custom.variants_option_title_general). When set, it replaces the option name.
    var generalTitle = ($variants.attr('data-option-title-general') || '').trim();

    // Color swatches
    var $colorWrap = $popup.find('.add-one_popup-variants-color');
    $colorWrap.find('.tac-color-option_scroller__outer').remove();
    var $colorSrc = $variants.find('.tac-color-option_scroller__outer').first();
    if ($colorSrc.length) {
      $colorWrap.append($colorSrc[0].cloneNode(true));
      var colorTitle = generalTitle || ($colorSrc.attr('data-option-name') || '');
      var activeColorVal = dehandelize($colorSrc.find('.tac-color-swatch.add_active').first().attr('data-value') || '');
      $colorWrap.find('.pp_variant_option-label-title').html(
        colorTitle + ': <span class="pp_variant_label_variant">' + activeColorVal + '</span>'
      );
    }

    // Type options + Standard/Pro product toggle (both are .tap-option_line).
    var $typeWrap = $popup.find('.add-one_popup-variants-type');
    $typeWrap.find('.tap-option_line').remove();
    var $typeLines = $variants.find('.tap-option_line');
    if ($typeLines.length) {
      $typeWrap.css('display', '');
      $typeLines.each(function () { $typeWrap.append(this.cloneNode(true)); });
      // Label comes from the real Type option; the Standard/Pro toggle shows none.
      var $labelType = $typeLines.not('.addon-toggle-line').first();
      if ($labelType.length) {
        var typeTitle = generalTitle || ($labelType.attr('data-option-name') || '');
        var activeTypeVal = $labelType.find('.tap-option_line-value.add_active').first().text().trim();
        $typeWrap.find('.pp_variant_option-label-title').html(
          typeTitle + ': <span class="pp_variant_label_variant">' + activeTypeVal + '</span>'
        );
      } else {
        $typeWrap.find('.pp_variant_option-label-title').html('');
      }
    } else {
      $typeWrap.css('display', 'none');
    }
  }

  function renderAccordions($context) {
    var $container = $popup.find('.add-one_popup_accordions');
    $container.empty();

    var $tpl = $context.find('template.addon-accordion-tpl').first();
    if (!$tpl.length || !$accordionTpl) return;

    var $items = $($tpl[0].content).find('.addon-accordion-item');
    if (!$items.length) return;

    // A single accordion whose collapsible content lists every metafield item
    // (icon + text). The thumb heading stays as rendered from section settings.
    var $accordion = $accordionTpl.clone();
    $accordion.addClass('active');
    var $content = $accordion.find('.add-one_popup_accordion_content');
    $content.css('display', 'block').empty();

    $items.each(function () {
      var $item = $(this);
      var $iconEl = $item.find('.addon-accordion-item__icon');
      var title = $item.find('.addon-accordion-item__title').text().trim();
      var text = $item.find('.addon-accordion-item__text').text().trim();

      var $row = $('<div class="add-one_popup_accordion_content__flex"></div>');
      $row.append('<div class="addon-accordion-item__icon">' + ($iconEl.length ? $iconEl.html() : '') + '</div>');

      // Same structure as `.desk_pdp-features-line`: bold title on its own line,
      // description paragraph below it.
      var $textEl = $('<div class="addon-accordion-item__text"></div>');
      if (title) $textEl.append($('<p class="desk_pdp-features-acc-title"></p>').text(title));
      if (text) $textEl.append($('<p class="desk_pdp-features-acc-text"></p>').text(text));
      $row.append($textEl);

      $content.append($row);
    });

    $container.append($accordion);
  }

  // Rating belongs to the selected add-on product, not the PDP product. Clone the
  // card's already-rendered .add-one_rating_line (correct star fill, count and
  // hidden/opacity state for the add-on's own desktronic_reviews.rating) into the popup,
  // replacing the static placeholder markup.
  function renderRating($context) {
    var $dest = $popup.find('.add-one_rating_line').first();
    if (!$dest.length) return;
    var $src = $context.find('.add-one_rating_line').first();
    if (!$src.length) {
      $dest.css('opacity', 0);
      return;
    }
    var $line = $($src[0].cloneNode(true));
    $dest.replaceWith($line);
    renderRatingCount($line);
  }

  function renderRatingCount($line) {
    var count = parseInt($line.attr('data-review-count'), 10);
    var $count = $line.find('.add-one_rating_count p').first();
    if (!$count.length) return;
    $count.find('.add-one_popup_rating-count').remove();
    if (!count) return;
    $count.append($('<span class="add-one_popup_rating-count"></span>').text('(' + count + ')'));
  }

  function renderInfo($context) {
    var title = $context.find('.tac-title').first().text().trim();
    $popup.find('.add-one_popup_title').text(title);
    // Description comes from the POPUP's (add-on) product, carried in a hidden
    // .tac-description in the card — not from the current PDP product.
    var $desc = $context.find('.tac-description').first();
    var $popupDesc = $popup.find('.add-one_popup_description');
    if ($desc.length) {
      $popupDesc.html($desc.html().trim());
    } else {
      $popupDesc.empty();
    }
    renderRating($context);
    renderPrices($context);
    renderVariants($context);
    renderAccordions($context);
  }

  function renderPrices($context) {
    if ($context.is('addon-chair-card')) {
      var chairPrice = $context.find('real-price[data-chair-price]').first().text().trim();
      var chairOriginal = $context.find('compare-price[data-chair-original-price]').first().text().trim();
      var chairCompareAt = $context.find('compare-price[data-chair-compare-price]').first().text().trim();
      setPopupPriceLine(chairPrice, chairOriginal, chairCompareAt, chairBadge(chairPrice, chairOriginal, chairCompareAt));
      return;
    }
    var price = $context.find('real-price').first().text().trim();
    var compare = $context.find('compare-price').first().text().trim();
    var discount = $context.find('price-discount').first().text().trim();
    // Only a real discount when compare is actually higher than the price
    var hasDiscount = priceToNumber(compare) > priceToNumber(price);
    setPopupPriceLine(price, compare, '', hasDiscount ? discount : '');
  }

  function renderSlides(slides) {
    if (swiperMain) { swiperMain.destroy(true, true); swiperMain = null; }

    var $mainList = $carousel.find('.addon-popup-main-list');
    $mainList.empty();

    if (!slides.length) return;

    slides.slice(1).forEach(function (slide) {
      var $img = $(slide).find('img');
      if (!$img.length) return;
      var src = $img.attr('src');
      if (!src) return;
      var $media = $('<div class="addon-popup-slide__media">').append(
        $('<img>').attr({ src: src, alt: $img.attr('alt') || '' })
      );

      var layout = $(slide).find('.desk-gallery-slide__layout')[0];
      if (layout) $media.append(document.importNode(layout, true));

      $mainList.append($('<li class="swiper-slide">').append($media));
    });

    var mainEl = document.getElementById('addon-popup-main-slider');
    var prevEl = $carousel.find('.addon-popup-nav--prev')[0];
    var nextEl = $carousel.find('.addon-popup-nav--next')[0];
    var paginationEl = document.getElementById('addon-popup-pagination');

    swiperMain = new Swiper(mainEl, {
      loop: false,
      navigation: { nextEl: nextEl, prevEl: prevEl },
      pagination: { el: paginationEl, clickable: true },
    });
  }

  function open($card, $context) {
    $activeCard = $card;
    $activeContext = $context || $card;
    $popup.addClass('is-open');
    $('body').addClass('addons-popup-open');
    window.lockScroll();
    renderSlides(getSlidesForCard($activeContext));
    renderInfo($activeContext);
    updateAddButton();
  }

  function close() {
    $popup.removeClass('is-open');
    $('body').removeClass('addons-popup-open');
    window.unlockScroll();
    $activeCard = null;
    $activeContext = null;
  }

  function onDetailsClick(e) {
    e.stopPropagation();
    var $card = $(this).closest('top-addon-card, addon-chair-card');
    if (!$card.length) return;
    var $upsell = $(this).closest('.ac_upsell');
    var $context = $upsell.length ? $upsell : $card;
    open($card, $context);
  }

  function onCloseClick() { close(); }

  function updateAddButton() {
    var isActive;
    if ($activeContext && $activeContext.is('.ac_upsell')) {
      isActive = $activeContext.find('.ac_upsell-box').hasClass('activated');
    } else {
      isActive = !!($activeCard && $activeCard.hasClass('activated'));
    }
    $popup.find('.desk_primary-btn[data="add"]').toggleClass('is-addon-active', isActive);
  }

  function onAddToCartClick() {
    if (!$activeCard) { close(); return; }
    if ($activeContext.is('.ac_upsell')) {
      $activeContext.find('.ac_upsell-box').trigger('click');
    } else {
      $activeCard.trigger('click');
    }
    close();
  }

  function onPopupClick(e) {
    if (e.target === e.currentTarget) close();
  }

  function onKeydown(e) {
    if (!$popup.hasClass('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (swiperMain) {
      if (e.key === 'ArrowLeft') swiperMain.slidePrev();
      if (e.key === 'ArrowRight') swiperMain.slideNext();
    }
  }

  function onVariantChange() {
    if (!$popup.hasClass('is-open') || !$activeCard) return;
    var $card = $(this).closest('top-addon-card, addon-chair-card');
    if ($card[0] !== $activeCard[0]) return;
    var $upsell = $(this).closest('.ac_upsell');
    var $context = $upsell.length ? $upsell : $card;
    if ($context[0] !== $activeContext[0]) return;
    renderSlides(getSlidesForCard($activeContext));
    renderPrices($activeContext);
  }

  // Standard/Pro toggle inside the popup: switch the popup — and the underlying
  // card selection + 3D — to the other product, then rebuild the popup from it.
  function onPopupProductToggle() {
    if (!$activeCard) return;
    var target = $(this).attr('data-toggle-target');
    var $box = $activeCard.closest('.addon-toggle-box');
    if (!$box.length) return;
    var $targetPanel = $box.find('.addon-toggle-panel[data-toggle-panel="' + target + '"]');
    var $targetCard = $targetPanel.find('top-addon-card').first();
    if (!$targetCard.length || $targetCard[0] === $activeCard[0]) return;

    if ($activeCard.hasClass('activated')) {
      // Addon already selected (3D on): drive the real card's toggle so the shown
      // product, selection and 3D all switch (handled in desk_addons.js).
      $activeCard.find('.addon-toggle-line .tap-option_line-value[data-toggle-target="' + target + '"]').first().trigger('click');
    } else {
      // Addon not selected yet: only switch which product is shown — do NOT
      // activate it or turn on 3D. Mirror the switch onto the real card so it's
      // correct when the popup closes / the shopper adds it.
      $box.find('.addon-toggle-line .tap-option_line-value').removeClass('add_active');
      $box.find('.addon-toggle-line .tap-option_line-value[data-toggle-target="' + target + '"]').addClass('add_active');
      $box.find('.addon-toggle-panel').removeClass('is-active');
      $targetPanel.addClass('is-active');
    }

    // Rebuild the popup from the now-shown product.
    $activeCard = $targetCard;
    $activeContext = $targetCard;
    renderSlides(getSlidesForCard($activeContext));
    renderInfo($activeContext);
    updateAddButton();
  }

  function onPopupSwatchClick() {
    if (!$activeContext) return;
    var $clicked = $(this);
    // The Standard/Pro toggle is a .tap-option_line-value too, but it's handled
    // by onPopupProductToggle — don't treat it as a variant selection.
    if ($clicked.closest('.addon-toggle-line').length) return;
    if ($clicked.hasClass('tac_disabled')) return;
    var isColorSwatch = $clicked.hasClass('tac-color-swatch');
    var productId = $clicked.attr('data-product-id');

    // Update active state in the popup
    if (isColorSwatch) {
      $popup.find('.add-one_popup-variants-color .tac-color-swatch').removeClass('add_active');
    } else {
      $popup.find('.add-one_popup-variants-type .tap-option_line-value').removeClass('add_active');
    }
    $clicked.addClass('add_active');

    // Update popup label
    var dataAttr = isColorSwatch ? 'data-value' : 'data-title';
    var dataValue = $clicked.attr(dataAttr);
    if (isColorSwatch) {
      $popup.find('.add-one_popup-variants-color .pp_variant_label_variant').text(dehandelize(dataValue));
    } else {
      $popup.find('.add-one_popup-variants-type .pp_variant_label_variant').text($clicked.text().trim());
    }

    // Mirror active state to the real card's variant selector
    var $cardVariants = $activeContext.find('.tac-variants').first();
    if (isColorSwatch) {
      $cardVariants.find('.tac-color-swatch').removeClass('add_active');
      $cardVariants.find('.tac-color-swatch[data-product-id="' + productId + '"][data-value="' + dataValue + '"]').addClass('add_active');
    } else {
      $cardVariants.find('.tap-option_line-value').removeClass('add_active');
      $cardVariants.find('.tap-option_line-value[data-product-id="' + productId + '"][data-title="' + dataValue + '"]').addClass('add_active');
    }

    // Build variant title from the card's .tac-variants DOM order so it matches addon_config-data
    var newTitle = '';
    $activeContext.find('.tac-variants .addon_config-option-sel[data-product-id="' + productId + '"].add_active').each(function () {
      var part = $(this).attr('data-title') || $(this).attr('data-value');
      newTitle = newTitle + '-' + part;
    });
    newTitle = newTitle.substring(1);

    var $configData = $activeContext.find('.addon_config-data[data-product-id="' + productId + '"][data-title="' + newTitle + '"]');
    if (!$configData.length) return;

    // Update the real card's input data; trigger change only if 3D is already active
    var $mainInput = $activeContext.children('input.addOneMainInput__js');
    if ($mainInput.length) {
      var mmqCode = $configData.attr('data-mmq-code') || $clicked.attr('data-mmq-code') || '';
      var mmqBlock = $configData.attr('data-mmq-option') || $clicked.attr('data-mmq-block') || '';
      $mainInput.attr('data-variant-id', $configData.attr('data-id') || '');
      $mainInput.attr('data-mmq-code', mmqCode);
      $mainInput.attr('data-mmq-option', mmqBlock);
      var is3dActive = $activeContext.is('.ac_upsell')
        ? $activeContext.find('.ac_upsell-box').hasClass('activated')
        : $activeCard.hasClass('activated');
      if (is3dActive) {
        $mainInput.trigger('change');
      }
    }

    // Update card prices and thumbnail image
    var discount = parseInt($configData.attr('data-discount')) || 0;
    var hasDiscount = discount > 0;
    var $imgTarget;
    if ($activeContext.is('addon-chair-card')) {
      var $info = $activeContext.find('.ac_content-info');
      $info.find('real-price[data-chair-price]').text($configData.attr('data-price-chair'));
      $info.find('compare-price[data-chair-original-price]').text($configData.attr('data-price'));
      $info.find('compare-price[data-chair-compare-price]').text($configData.attr('data-compare')).toggle(hasDiscount);
      // Discount = saving vs the FULL compare price (compare-at when on sale, else the
      // original price), measured against the chair price. Chairs ALWAYS carry the 5%
      // chair saving, so the badge shows even without a variant sale (`chairHasDiscount`,
      // not `hasDiscount`). Own % so percent-mode works without a variant discount.
      var chairCardWas = priceToNumber($configData.attr('data-compare')) > priceToNumber($configData.attr('data-price'))
        ? $configData.attr('data-compare')
        : $configData.attr('data-price');
      var chairWasNum = priceToNumber(chairCardWas);
      var chairPriceNum = priceToNumber($configData.attr('data-price-chair'));
      var chairPct = chairWasNum > 0 ? Math.round((chairWasNum - chairPriceNum) / chairWasNum * 100) : 0;
      $info.find('price-discount').text(window.deskDiscountBadge(chairPct, $configData.attr('data-price-chair'), chairCardWas)).toggle(chairWasNum > chairPriceNum);
      $imgTarget = $activeContext.find('.ac_content-media img');
    } else if ($activeContext.is('.ac_upsell')) {
      var $upsellContent = $activeContext.find('.ac_upsell-content');
      $upsellContent.find('real-price').text($configData.attr('data-price'));
      $upsellContent.find('compare-price').text($configData.attr('data-compare')).toggle(hasDiscount);
      $upsellContent.find('price-discount').text(window.deskDiscountBadge(discount, $configData.attr('data-price'), $configData.attr('data-compare'))).toggle(hasDiscount);
      $imgTarget = $activeContext.find('.ac_upsell-media__image img');
    } else {
      $activeContext.find('real-price').text($configData.attr('data-price'));
      $activeContext.find('compare-price').text($configData.attr('data-compare')).toggle(hasDiscount);
      $activeContext.find('price-discount').text(window.deskDiscountBadge(discount, $configData.attr('data-price'), $configData.attr('data-compare'))).toggle(hasDiscount);
      $imgTarget = $activeContext.find('.top-addon-card-image img');
    }
    var newSrc = $configData.attr('data-image');
    if (newSrc && $imgTarget && $imgTarget.length) {
      var swapImg = new Image();
      swapImg.onload = function () { $imgTarget.attr('src', newSrc); };
      swapImg.src = newSrc;
    }

    // Update popup prices
    if ($activeContext.is('addon-chair-card')) {
      var chairPrice = $configData.attr('data-price-chair');   // variant price * 0.95
      var chairOriginal = $configData.attr('data-price');      // original variant price
      var chairCompareAt = $configData.attr('data-compare');   // variant compare-at (if any)
      setPopupPriceLine(chairPrice, chairOriginal, chairCompareAt, chairBadge(chairPrice, chairOriginal, chairCompareAt));
    } else {
      var popupPrice = $configData.attr('data-price');
      var popupCompare = $configData.attr('data-compare');
      // Only show compare price / badge when it's a real discount (compare actually higher than price)
      var popupHasDiscount = hasDiscount && priceToNumber(popupCompare) > priceToNumber(popupPrice);
      // Badge honours the discount-format setting (percent vs saved amount), like the
      // <price-discount> element above — was hardcoded to `-N%`.
      var popupBadge = window.deskDiscountBadge
        ? window.deskDiscountBadge(discount, popupPrice, popupCompare)
        : '-' + discount + '%';
      setPopupPriceLine(popupPrice, popupCompare, '', popupHasDiscount ? popupBadge : '');
    }

    // Update popup gallery
    renderSlides(getSlidesForCard($activeContext));
  }

  function bindEvents() {
    $(document).on('click', '.tac__details', onDetailsClick);
    $(document).on('click', '.desk_product-addons-popup__close, .desk_product-addons-close-icon', onCloseClick);
    document.addEventListener('keydown', onKeydown, true);
    $(document).on('change', 'top-addon-card input.addOneMainInput__js, addon-chair-card input.addOneMainInput__js', onVariantChange);
    $popup[0].addEventListener('click', onPopupClick);
    $popup.on('click', '.desk_primary-btn[data="add"]', onAddToCartClick);
    $popup.on('click', '.tac-color-swatch, .tap-option_line-value', onPopupSwatchClick);
    $popup.on('click', '.addon-toggle-line .tap-option_line-value', onPopupProductToggle);
    $popup.on('click', '.add-one_popup_accordion', function () {
      var $accordion = $(this);
      $accordion.toggleClass('active');
      $accordion.find('.add-one_popup_accordion_content').slideToggle(300);
    });
  }

  function init() {
    $popup = $('.desk_product-addons-popup');
    $carousel = $popup.find('.desk_product-addons-popup-media__carousel');
    if (!$popup.length) return;

    $accordionTpl = $popup.find('.add-one_popup_accordion').first().clone();
    $popup.find('.add-one_popup_accordions').empty();

    bindEvents();
  }

  return { open: open, close: close, init: init };
}(jQuery));

$(function () { window.addonsPopup.init(); });
